import { RouterStateSnapshot } from "@angular/router";
import { RouterStateSerializer } from "@ngrx/router-store";
import { SLOT } from "src/app/common/enums/slot";
import { RouterStateUrl } from "src/app/common/interfaces/router-state-url";
import { isModalPlugin } from "../guards/is-modal-plugin.matcher";

/** matches the slot route param. For example, in
 * /regions/86b6e66c-3e2e-5e06-82b6-7d55f9a33818/some-module/deep/route#anchor?with=query
 * it would match "some-module". */
const slotRegex = /(\/regions\/[^\/]+\/)([^\/\#\?]*)/;

/**
 * @description https://ngrx.io/guide/router-store/configuration
 */
export class ProjectRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  public serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams }
    } = routerState;
    const { params } = route;
    const [, , slotParam] = url?.match(slotRegex) ?? [];

    const slot = isModalPlugin(slotParam) ? SLOT.LANDING : Object.values(SLOT).find((value) => value === slotParam);

    return { url, slot, params, queryParams };
  }
}
